export default {
	"90ac816d857bbd244c491943313396cc": "確認訂單收銀台-用户協議彈窗",
	"0cefacbbe66660bed470586ecf1cb162": "請確認您已閲讀並同意",
	"d53798ced405bd77a839d0d4193c147b": "《用户服務協議》",
	"e03a7b37418172722525e17c8de3280b": "《自動續費協議》",
	"4cb2ee263648fa364d0ceaa27a8ef3a7": "《用户購買協議》",
	"5dc192f57b70d0ab967759cd475ee2ed": "返回",
	"6115eba37649fb1c1124157bbd77e7d1": "同意並繼續"
}
